<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 487.32 529.9"
    class="svg-icon relative"
    style="font-size: 0.7em; top: -0.15em;"
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          class="cls-1"
          d="M22.35,499.11,225,158.08a20.39,20.39,0,0,1,35,0l202.87,341a20.38,20.38,0,0,1-17.51,30.8H39.87A20.38,20.38,0,0,1,22.35,499.11Z"
        />
        <rect class="cls-2" width="487.32" height="61.02" rx="20.64" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "IconSortIncrease"
};
</script>
